<!-- CREATE & EDIT -->
@if (editMode) {
    <mds-dialog id="editCaregiverData" dialogTitle="{{ isNewCaregiver ? 'Add New Caregiver' : 'Caregiver Profile' }}">
        @if (editMode) {
            <mds-dialog-content>
                <div class="caregiver-info">
                    <div class="o-grid">
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <div class="flex start middle">
                                    <span class="required-asterisk">*</span>
                                    <span class="note"> indicates a required field </span>
                                </div>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <mds-checkbox
                                    (changeEvent)="selectValue($event, 'isPrimary')"
                                    [disabled]="isDisabled"
                                    class="make-primary-field"
                                    formCtrlName="isPrimary"
                                    [formGrp]="caregiverInfoFormGroup"
                                    label="Make Primary?"
                                    id="isPrimaryCheckbox"
                                >
                                </mds-checkbox>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__field">
                                <mds-text-field
                                    [formGrp]="caregiverInfoFormGroup"
                                    formCtrlName="firstName"
                                    id="firstName"
                                    placeholder="Type here..."
                                    appearance="outline"
                                    inputType="text"
                                    label="First/Given Name"
                                    width="100%"
                                ></mds-text-field>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__field">
                                <mds-text-field
                                    [formGrp]="caregiverInfoFormGroup"
                                    formCtrlName="middleName"
                                    id="middleName"
                                    placeholder="Type here..."
                                    appearance="outline"
                                    inputType="text"
                                    label="Middle Name"
                                    width="100%"
                                ></mds-text-field>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__field">
                                <mds-text-field
                                    [formGrp]="caregiverInfoFormGroup"
                                    formCtrlName="lastName"
                                    id="lastName"
                                    placeholder="Type here..."
                                    appearance="outline"
                                    inputType="text"
                                    label="Last/Surname"
                                    width="100%"
                                ></mds-text-field>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__field">
                                <mds-text-field
                                    [formGrp]="caregiverInfoFormGroup"
                                    formCtrlName="phoneNumber"
                                    id="phoneNumber"
                                    placeholder="Type here..."
                                    appearance="outline"
                                    inputType="text"
                                    label="Phone Number"
                                    width="100%"
                                ></mds-text-field>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__field">
                                <mds-text-field
                                    [formGrp]="caregiverInfoFormGroup"
                                    formCtrlName="email"
                                    id="email"
                                    placeholder="Type here..."
                                    appearance="outline"
                                    inputType="text"
                                    label="Email Address"
                                    width="100%"
                                ></mds-text-field>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__field">
                                <mds-text-field
                                    [formGrp]="caregiverInfoFormGroup"
                                    formCtrlName="relationshipToPatient"
                                    id="relationshipToPatient"
                                    placeholder="Type here..."
                                    appearance="outline"
                                    inputType="text"
                                    floatLabel="always"
                                    label="Relationship to Patient"
                                    width="100%"
                                ></mds-text-field>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__field">
                                <mds-text-field
                                    [formGrp]="caregiverInfoFormGroup"
                                    formCtrlName="language"
                                    id="language"
                                    placeholder="Type here..."
                                    appearance="outline"
                                    inputType="text"
                                    label="Preferred Language"
                                    width="100%"
                                ></mds-text-field>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <label
                                    >Gender
                                    <span class="required-asterisk">*</span>
                                </label>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__field">
                                <mds-radio-group
                                    [buttons]="genderRadioButtons"
                                    [formGrp]="caregiverInfoFormGroup"
                                    formCtrlName="gender"
                                    id="gender"
                                    (changeEvent)="selectValue($event, 'gender')"
                                >
                                </mds-radio-group>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__field">
                                <medpace-datepicker
                                    [formGrp]="caregiverInfoFormGroup"
                                    formCtrlName="birthDate"
                                    id="birthDate"
                                    appearance="outline"
                                    [required]="true"
                                    label="Birthdate"
                                ></medpace-datepicker>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <label
                                    >Same Address as Patient?
                                    <span class="required-asterisk">*</span>
                                </label>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__field">
                                <mds-radio-group
                                    [buttons]="adressRadioButtons"
                                    [formGrp]="caregiverInfoFormGroup"
                                    formCtrlName="addressSameAsPatient"
                                    id="sameAdress"
                                    (changeEvent)="selectValue($event, 'addressSameAsPatient')"
                                >
                                </mds-radio-group>
                                @if (
                                    caregiverInfoFormGroup.get('addressSameAsPatient').hasError('required') &&
                                    caregiverInfoFormGroup.get('addressSameAsPatient').touched
                                ) {
                                    <mat-error> This field is required </mat-error>
                                }
                            </div>
                        </div>
                        @if (showAddressFields) {
                            <div>
                                <div class="o-grid__row">
                                    <div class="o-grid__field">
                                        <mds-text-field
                                            [formGrp]="caregiverInfoFormGroup"
                                            formCtrlName="address1"
                                            id="caregiverAddress1"
                                            placeholder="Type here..."
                                            appearance="outline"
                                            inputType="text"
                                            label="Address Line 1"
                                            width="100%"
                                            appGoogleMapsAutocomplete
                                            (placeChangeEvent)="googleMapsAutocompletePlaceChange($event)"
                                        ></mds-text-field>
                                    </div>
                                </div>
                                <div class="o-grid__row">
                                    <div class="o-grid__field">
                                        <mds-text-field
                                            [formGrp]="caregiverInfoFormGroup"
                                            formCtrlName="address2"
                                            id="address2"
                                            placeholder="Type here..."
                                            appearance="outline"
                                            inputType="text"
                                            label="Address Line 2"
                                            width="100%"
                                        ></mds-text-field>
                                    </div>
                                </div>
                                <div class="o-grid__row">
                                    <div class="o-grid__field">
                                        <mds-text-field
                                            [formGrp]="caregiverInfoFormGroup"
                                            formCtrlName="city"
                                            id="city"
                                            placeholder="Type here..."
                                            appearance="outline"
                                            inputType="text"
                                            label="City"
                                            width="100%"
                                        ></mds-text-field>
                                    </div>
                                </div>
                                <div class="o-grid__row">
                                    <div class="o-grid__field">
                                        <mds-text-field
                                            [formGrp]="caregiverInfoFormGroup"
                                            formCtrlName="state"
                                            id="state"
                                            placeholder="Type here..."
                                            appearance="outline"
                                            inputType="text"
                                            [label]="regionStateType$ | async"
                                            width="100%"
                                        ></mds-text-field>
                                    </div>
                                </div>
                                <div class="o-grid__row">
                                    <div class="o-grid__field">
                                        <mds-text-field
                                            [formGrp]="caregiverInfoFormGroup"
                                            formCtrlName="zipCode"
                                            id="zipCode"
                                            placeholder="Type here..."
                                            appearance="outline"
                                            inputType="text"
                                            label="Zipcode/Postal Code"
                                            width="100%"
                                        ></mds-text-field>
                                    </div>
                                </div>
                                @if (countries$ | async; as countries) {
                                    <div class="o-grid__field">
                                        <mds-autocomplete
                                            [closeOnPageScroll]="false"
                                            [formGrp]="caregiverInfoFormGroup"
                                            [disableRipple]="false"
                                            [options]="countries"
                                            appearance="outline"
                                            placeholder="Enter country"
                                            label="Country"
                                            id="country"
                                            inputType="text"
                                            formCtrlName="country"
                                            [validateInput]="true"
                                        >
                                        </mds-autocomplete>
                                    </div>
                                }
                            </div>
                        }
                        <div class="o-grid__row">
                            <div class="o-grid__field">
                                <mds-text-field
                                    [formGrp]="caregiverInfoFormGroup"
                                    formCtrlName="additionalDetails"
                                    id="additionalDetails"
                                    placeholder="Type here..."
                                    appearance="outline"
                                    inputType="text"
                                    label="Additional Details"
                                    width="100%"
                                ></mds-text-field>
                            </div>
                        </div>
                        @if (isNewCaregiver) {
                            <div class="o-grid__row">
                                <div class="o-grid__item u-ta-left">
                                    @if (showValidationMessage) {
                                        <span class="c-message__show">{{ validationMessage }}</span>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </mds-dialog-content>
        }
        <mds-dialog-actions [align]="'end'">
            <div class="flex flex-row gap-medpace">
                <ng-container *ngTemplateOutlet="closeButton"></ng-container>
                @if (isNewCaregiver) {
                    <mds-button
                        (clickEvent)="closeDialog(true)"
                        [color]="'primary'"
                        [variant]="'filled'"
                        label="Add caregiver"
                        [id]="'AddNewCaregiverBtn'"
                    ></mds-button>
                } @else {
                    <mds-button
                        [id]="'save-btn'"
                        [color]="'primary'"
                        [variant]="'filled'"
                        label="Save"
                        (clickEvent)="closeDialog(true)"
                    ></mds-button>
                }
            </div>
        </mds-dialog-actions>
    </mds-dialog>
}
<!-- VIEW -->
@if (!editMode) {
    <mds-dialog id="editCaregiverData" dialogTitle="Caregiver Profile">
        @if (!editMode) {
            <mds-dialog-content>
                <div class="caregiver-info">
                    <div class="o-grid">
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <div class="c-info__block">
                                    <h5>Primary Caregiver?</h5>
                                    <span>{{ selectedCaregiver.isPrimary ? 'Yes' : 'No' }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <div class="c-info__block">
                                    <h5>
                                        First/Given Name<i class="note">{{ asListedOnGovID }}</i>
                                    </h5>
                                    <span>{{ selectedCaregiver.firstName }}</span>
                                </div>
                            </div>
                        </div>
                        @if (selectedCaregiver.middleName) {
                            <div class="o-grid__row">
                                <div class="o-grid__item">
                                    <div class="c-info__block">
                                        <h5>
                                            Middle Name<i class="note">{{ asListedOnGovID }}</i>
                                        </h5>
                                        <span>{{ selectedCaregiver.middleName }}</span>
                                    </div>
                                </div>
                            </div>
                        }
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <div class="c-info__block">
                                    <h5>
                                        Last/Surname<i class="note">{{ asListedOnGovID }}</i>
                                    </h5>
                                    <span>{{ selectedCaregiver.lastName }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <div class="c-info__block">
                                    <h5>Phone Number</h5>
                                    <span>{{ selectedCaregiver.phone }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <div class="c-info__block">
                                    <h5>Email Address</h5>
                                    <span>{{ selectedCaregiver.email }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <div class="c-info__block">
                                    <h5>Relationship to Patient</h5>
                                    <span>{{ selectedCaregiver.relationship }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <div class="c-info__block">
                                    <h5>Preferred Language</h5>
                                    <span>{{ selectedCaregiver.preferredLang }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <div class="c-info__block">
                                    <h5>Gender</h5>
                                    <span>{{ selectedCaregiver.gender | titlecase }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <div class="c-info__block">
                                    <h5>Birthdate</h5>
                                    <span>{{ birthDate?.toDate() | dateFormat | uppercase }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <div class="c-info__block">
                                    <h5>Same Address as Patient?</h5>
                                    <span>{{ selectedCaregiver.addressSameAsPatient ? 'Yes' : 'No' }}</span>
                                </div>
                            </div>
                        </div>
                        @if (selectedCaregiver.addressSameAsPatient === false) {
                            <div>
                                <div class="o-grid__row">
                                    <div class="o-grid__item">
                                        <div class="c-info__block">
                                            <h5>Address Line 1</h5>
                                            <span>{{ selectedCaregiver.address1 }}</span>
                                        </div>
                                    </div>
                                </div>
                                @if (selectedCaregiver.address2) {
                                    <div class="o-grid__row">
                                        <div class="o-grid__item">
                                            <div class="c-info__block">
                                                <h5>Address Line 2</h5>
                                                <span>{{ selectedCaregiver.address2 }}</span>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div class="o-grid__row">
                                    <div class="o-grid__item">
                                        <div class="c-info__block">
                                            <h5>City</h5>
                                            <span>{{ selectedCaregiver.city }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="o-grid__row">
                                    <div class="o-grid__item">
                                        <div class="c-info__block">
                                            <h5>{{ regionStateType$ | async }}</h5>
                                            <span>{{ selectedCaregiver.state }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="o-grid__row">
                                    <div class="o-grid__item">
                                        <div class="c-info__block">
                                            <h5>Zipcode/Postal Code</h5>
                                            <span>{{
                                                !!selectedCaregiver.zipcode ? selectedCaregiver.zipcode : 'Unspecified'
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="o-grid__row">
                                    <div class="o-grid__item">
                                        <div class="c-info__block">
                                            <h5>Country</h5>
                                            <span>{{ selectedCaregiver.country }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        @if (selectedCaregiver.details) {
                            <div class="o-grid__row">
                                <div class="o-grid__item">
                                    <div class="c-info__block">
                                        <h5>Additional Details</h5>
                                        <span>{{ selectedCaregiver.details }}</span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </mds-dialog-content>
        }
        <mds-dialog-actions [align]="'end'">
            <div class="flex flex-row gap-medpace">
                <ng-container *ngTemplateOutlet="closeButton"></ng-container>
                @if (canEdit) {
                    <mds-button
                        [id]="'editBtn'"
                        [color]="'primary'"
                        [variant]="'filled'"
                        label="Edit"
                        (clickEvent)="editCaregiver()"
                    ></mds-button>
                }
            </div>
        </mds-dialog-actions>
    </mds-dialog>
}
<!-- BUTTON TEMPLATES -->
<ng-template #closeButton>
    <mds-button [id]="'cancel-btn'" (clickEvent)="closeDialog(false)" variant="outline" label="Cancel"></mds-button>
</ng-template>
